export default function getCharacter (length) {
    return String.fromCharCode("a".charCodeAt(0) + length);
};